var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.49331 0.286621L4.95747 3.82162L1.42247 0.286621L0.244141 1.46495L3.77914 4.99995L0.244141 8.53496L1.42247 9.71329L4.95747 6.17829L8.49331 9.71329L9.67164 8.53496L6.13664 4.99995L9.67164 1.46495L8.49331 0.286621Z","fill":"#333F48"}));
}

CloseInline.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
